

export enum RelationshipStatus {
    Single,
    Married,
    In_A_Relationship,
}

